import { Component, OnInit } from '@angular/core';
import { SessionContext } from 'src/app/core/services/config/app.settings';
import { UtilisateurTypeCode } from 'src/app/data/intervenant/models/enums/type-utilisateur.enum';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
    isOrganismeAnpp = false;
    isProducteurAnpp = false;

    ngOnInit() {
        if (SessionContext.get('codeDomaine') === 'ANPP') {
            if (SessionContext.get('utilisateurType') === UtilisateurTypeCode.ORGANISME) {
                this.isOrganismeAnpp = true;
            } else if (
                SessionContext.get('utilisateurType') === UtilisateurTypeCode.PI ||
                SessionContext.get('utilisateurType') === UtilisateurTypeCode.PO ||
                SessionContext.get('utilisateurType') === UtilisateurTypeCode.GP ||
                SessionContext.get('utilisateurType') === UtilisateurTypeCode.CT ||
                SessionContext.get('utilisateurType') === UtilisateurTypeCode.OC
            ) {
                this.isProducteurAnpp = true;
            }
        }
    }
}
